import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cc-lg-color-bubble-set',
  templateUrl: './color-bubble-set.component.html',
  styleUrls: ['./color-bubble-set.component.scss']
})
export class ColorBubbleSetComponent implements OnInit {
  @Input() control: FormControl;
  constructor() {}

  ngOnInit() {}
}
